<template>
  <button class="ot-back-button" @click="buttonClicked">
    <img
      v-if="forward"
      src="../assets/images/forward-button.png"
      alt="Forward"
    />
    <img v-else src="../assets/images/back-button.png" alt="Back" />
  </button>
</template>

<script setup>
import { inject } from "vue";

const audioManager = inject("audioManager");

const emit = defineEmits(["click"]);

const props = defineProps({
  forward: {
    type: Boolean,
    default: false,
  },
});
const buttonClicked = (event) => {
  event.stopPropagation();
  audioManager.play("click").then(() => {
    emit("click", event);
  });
};
</script>

<style scoped lang="scss">
.ot-back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  img {
    width: 50px;
  }
  &:active {
    transform: translate3d(2px, 2px, 0);
    filter: brightness(0.9);
  }
}
@media (max-width: 768px) {
  .ot-back-button {
    img {
      width: 40px;
    }
  }
}
</style>
